export default "__VITE_ASSET__DBcJILc4__"